// The cart's Check out stays gray until the buyer ticks the Terms of Use box. The Cart Terms Checkbox app
// (tos-remix) gives the button disabled, pointer-events: none and opacity 0.5, so a tap on it lands on whatever is
// under it and nothing answers. This script catches that tap, brings the box into view, outlines it and says what
// to do, and records the tap in GA4 as checkout_blocked_terms through vv-ga4.js, with the visitor's analytics consent,
// so the store can count the buyers the box stops. The app, its box and its settings stay as they are.
(() => {
  const message = document.currentScript?.dataset.message;
  if (!message || window.vvCheckoutTerms) return;
  window.vvCheckoutTerms = true;

  const GATES = [
    ['#CartDrawer-Checkout', 'cart_drawer'],
    ['#checkout', 'cart_page'],
  ];
  let taps = 0;

  const style = document.createElement('style');
  style.textContent = [
    '.vv-terms-nudge{outline:2px solid #b94d20;outline-offset:4px;border-radius:4px}',
    '.vv-terms-nudge--pulse{animation:vv-terms-pulse .45s ease-in-out 2}',
    '@keyframes vv-terms-pulse{50%{outline-offset:7px;outline-color:#df703d}}',
    '.vv-terms-nudge__message{margin:8px 0 0;font-size:13px;font-weight:700;line-height:1.4;color:#b94d20;text-align:left}',
    '@media (prefers-reduced-motion:reduce){.vv-terms-nudge--pulse{animation:none}}',
  ].join('');
  document.head.appendChild(style);

  const isGray = (element) => element.disabled || element.hasAttribute('disabled') || element.classList.contains('disabled')
    || getComputedStyle(element).pointerEvents === 'none';

  // The Terms box that gates an element. The app puts it just before the button, so it is within a few levels;
  // the walk stops there, since the cart drawer's box is somewhere in every page.
  const termsBoxFor = (element) => {
    let scope = element.parentElement;
    for (let level = 0; scope && level < 3; level += 1, scope = scope.parentElement) {
      const box = scope.querySelector('.tos-app-extension:not(.d-none) input.agreement__checkbox');
      if (box) return box;
    }
    return null;
  };

  // The tap counts only when it reached the gray button's own part of the page, the box around the button. A drawer,
  // a header or a dialog drawn over the button takes the tap itself, and its target does not hold the button.
  const blockedAt = (x, y, target) => {
    for (const [selector, location] of GATES) {
      for (const element of document.querySelectorAll(selector)) {
        const rect = element.getBoundingClientRect();
        if (!rect.width || x < rect.left || x > rect.right || y < rect.top || y > rect.bottom || !isGray(element)) continue;
        if (!target?.contains(element)) continue;
        const box = termsBoxFor(element);
        if (box && !box.checked) return { box, location };
      }
    }
    return null;
  };

  const record = (location) => {
    window.vvGa4?.event('checkout_blocked_terms', { cart_location: location, tap_number: taps });
  };

  const nudge = (box) => {
    const row = box.closest('.agreement__container') || box.parentElement;
    let note = row.parentElement.querySelector(':scope > .vv-terms-nudge__message');
    if (!note) {
      note = document.createElement('p');
      note.className = 'vv-terms-nudge__message';
      note.setAttribute('role', 'alert');
      row.insertAdjacentElement('afterend', note);
    }
    note.textContent = '';
    requestAnimationFrame(() => { note.textContent = message; });
    row.classList.remove('vv-terms-nudge--pulse');
    void row.offsetWidth;
    row.classList.add('vv-terms-nudge', 'vv-terms-nudge--pulse');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    row.scrollIntoView({ block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
    box.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    // A click the keyboard made has no point on the screen; a gray button cannot take focus anyway.
    if (event.detail === 0) return;
    const blocked = blockedAt(event.clientX, event.clientY, event.target);
    if (!blocked) return;
    taps += 1;
    nudge(blocked.box);
    record(blocked.location);
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches?.('input.agreement__checkbox') || !event.target.checked) return;
    document.querySelectorAll('.vv-terms-nudge').forEach((row) => row.classList.remove('vv-terms-nudge', 'vv-terms-nudge--pulse'));
    document.querySelectorAll('.vv-terms-nudge__message').forEach((note) => note.remove());
  });
})();
